import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Hero from "@/pages/home/components/Hero";
import IntroSection from "@/pages/home/components/IntroSection";
import BusinessCards from "@/pages/home/components/BusinessCards";
import PartnersSection from "@/pages/home/components/PartnersSection";
import FaqSection from "@/pages/home/components/FaqSection";
import NewsSection from "@/pages/home/components/NewsSection";
import ContactSection from "@/pages/home/components/ContactSection";
import { useSeo } from "@/lib/useSeo";
import { useTranslation } from "react-i18next";

// 홈은 인상과 입구 역할만 합니다. 상세 내용은 서브페이지(회사소개·서비스·솔루션·위성통신)에 있습니다.
export default function Home() {
  const { t } = useTranslation();
  useSeo({ title: t("seo.home.title"), description: t("seo.home.desc") });

  return (
    <div className="min-h-screen bg-background-50 text-foreground-900">
      <Navbar />
      <main>
        <Hero />
        {/* 히어로 위를 덮으며 올라오는 커튼 영역 */}
        <div className="hero-curtain">
          <IntroSection />
          <PartnersSection compact />
          <BusinessCards />
          <FaqSection />
          <NewsSection />
          <ContactSection />
        </div>
      </main>
      <Footer />
    </div>
  );
}
